// Motivational quotes shown during the 10 second drill countdown
export const motivationalQuotes: string[] = [
  "Follow your passion and you'll be successful. - Duane Ludwig",
  "A champion is someone who sweats to exhaustion, even when no one else is watching. - Bas Rutten",
  "Belief is a powerful thing. - TJ Dillashaw"
];
